// extracted by mini-css-extract-plugin
export default {"head":"about_head__g4wlb","info":"about_info__RlEqp","part":"about_part__mdu+c","en":"about_en__vU-gi","ar":"about_ar__k-aBk"};